import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';

export interface FieldListItem {
  key: string;
  displayLabel: string;
  defaultLabel?: string;
}

export interface FieldListProps {
  fields: FieldListItem[];
  selectedFieldKey: string | null;
  onSelectField: (key: string) => void;
}

export const FieldList = ({
  fields,
  selectedFieldKey,
  onSelectField,
}: FieldListProps) => (
  <ul className="vai-p-3">
    {fields.map((field) => {
      const isSelected = selectedFieldKey === field.key;
      return (
        <li key={field.key}>
          <button
            type="button"
            onClick={() => onSelectField(field.key)}
            className={`vai-w-full vai-flex vai-items-center vai-gap-3 vai-rounded-md vai-px-3 vai-py-3 vai-min-h-12 vai-text-left vai-cursor-pointer vai-border-l-4 hover:vai-bg-gray-50 vai-transition-colors ${
              isSelected
                ? 'vai-border-l-blue-600 vai-bg-blue-50'
                : 'vai-border-l-transparent'
            }`}
          >
            <div className="vai-flex-1 vai-min-w-0">
              <div className="vai-font-medium vai-text-gray-900 vai-truncate">
                {field.displayLabel}
              </div>
            </div>
            {field.defaultLabel != null && field.defaultLabel !== '' && (
              <span className="vai-inline-flex vai-shrink-0 vai-items-center vai-h-8 vai-px-2.5 vai-rounded-full vai-text-sm vai-font-medium vai-leading-none vai-bg-leaf-600 vai-text-primary-foreground">
                <Trans>Default</Trans>: {field.defaultLabel}
              </span>
            )}
            <FontAwesomeIcon
              icon={faChevronRight}
              className="vai-h-4 vai-w-4 vai-text-gray-400 vai-shrink-0"
            />
          </button>
        </li>
      );
    })}
  </ul>
);
